export default __webpack_public_path__ + "static/media/icon_home_bleu.33bbf791.svg";